// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const porygon_z: PokeData = {
  "id": 474,
  "name": "porygon-z",
  "height": 9,
  "weight": 340,
  "base_experience": 241,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "tackle",
    "double-edge",
    "psybeam",
    "hyper-beam",
    "thunder-shock",
    "thunderbolt",
    "thunder-wave",
    "agility",
    "recover",
    "defense-curl",
    "conversion",
    "tri-attack",
    "conversion-2",
    "zap-cannon",
    "lock-on",
    "spark",
    "magic-coat",
    "recycle",
    "signal-beam",
    "embargo",
    "magnet-rise",
    "nasty-plot",
    "trick-room",
    "discharge"
  ],
  "moves": [
    "tackle",
    "thunder-shock",
    "thunderbolt",
    "tri-attack",
    "zap-cannon",
    "refresh",
    "scary-face",
    "splash",
    "leer",
    "quick-attack",
    "purification",
    "growl",
    "body-slam"
  ],
  "evolution_chain": {
    "id": 68,
    "item": null,
    "species": [
      {
        "name": "porygon",
        "order": 166,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "porygon2",
        "order": 167,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 137,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      },
      {
        "name": "porygon-z",
        "order": 168,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 233,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 104,
    "speed": 119,
    "ability_power": 178
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
